// extracted by mini-css-extract-plugin
export default {"training":"training_training__L1ZK1"};